import React from 'react'

function ResultPagination(props) {
    return (
        <div className="tribe-list-pagination">
            <ul className="pagination">
                { props.searchPage > 1 &&
                    <li className="page-previous"><a className="gotoPrevPage" onClick={props.handlePrevPageClick}>« Previous</a></li>
                }
                
                { props.searchPage > 4 &&
                    <li><a onClick={(e) => props.handlePageClick(e, props.firstPage)}>{props.firstPage}</a> ...</li>
                }

                { [3,2,1].map(i => (
                    <React.Fragment key={i}>
                    { props.searchPage > i &&
                        <li><a onClick={(e) => props.handlePageClick(e, props.searchPage - i)}>{props.searchPage - i}</a></li>
                    }
                    </React.Fragment>
                ))}

                <li className="page-current"><span>{props.searchPage}</span></li>

                { [1,2,3].map(i => (
                    <React.Fragment key={i}>
                    { props.lastPage - props.searchPage > (i-1) &&
                        <li><a onClick={(e) => props.handlePageClick(e, props.searchPage + i)}>{props.searchPage + i}</a></li>
                    }
                    </React.Fragment>
                ))}

                { props.lastPage - props.searchPage > 3 &&
                    <li>... <a onClick={(e) => props.handlePageClick(e, props.lastPage)}>{props.lastPage}</a></li>
                }
                
                { props.searchPage < props.lastPage &&
                    <li className="page-next"><a className="gotoNextPage" onClick={props.handleNextPageClick}>Next »</a></li>
                }
            </ul>
        </div>
    )
}

export default ResultPagination